/** Festive gifting FAQ entries (question/answer keys in the performance-lab catalog). */
export const FESTIVE_FAQ_ITEMS = [
  {
    questionKey: 'festive.faq.items.transfer.question',
    answerKey: 'festive.faq.items.transfer.answer',
  },
  {
    questionKey: 'festive.faq.items.refund.question',
    answerKey: 'festive.faq.items.refund.answer',
  },
  {
    questionKey: 'festive.faq.items.outsideBengaluru.question',
    answerKey: 'festive.faq.items.outsideBengaluru.answer',
  },
  {
    questionKey: 'festive.faq.items.prepare.question',
    answerKey: 'festive.faq.items.prepare.answer',
  },
] as const;
